import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UpdateSupervisorListing from './UpdateSupervisorListing';
import { updateSupervisorListData, getSupervisorListData } from "services/redux/Valet/Supervisor/action";

const mapStateToProps = (state) => ({
    updateValetListData: state.CreateSupervisor.updateValetListData,
    supervisorListData: state.CreateSupervisor.supervisorListData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        updateSupervisorListData,
        getSupervisorListData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSupervisorListing);
